/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MultiplierLvlDto } from './multiplierLvlDto';
import { ShiftLvlDto } from './shiftLvlDto';
import { ChangerLvlDto } from './changerLvlDto';

export interface RiskSettings {
  shifts?: Array<ShiftLvlDto>;
  askChangers?: Array<ChangerLvlDto>;
  bidChangers?: Array<ChangerLvlDto>;
  askSpreadMultiplier?: Array<MultiplierLvlDto>;
  bidSpreadMultiplier?: Array<MultiplierLvlDto>;
}
